export default __webpack_public_path__ + "static/media/(23).2d79d3b7.jpg";